import { useEffect, useState } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { BrunoBalkProtocol } from '~/modules/aerobicCapabilities/schema'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'

export const BrunoBalk: React.FC = () => {
  const data = evaluationAtom.get()
  const [value, setValue] = useState<BrunoBalkProtocol>({
    distance: data?.brunoBalk?.distance ?? 0,
    time: data?.brunoBalk?.time ?? 0,
  })

  useEffect(() => {
    patchEvaluationAtom({ brunoBalk: value })
  }, [value])

  return (
    <div className='flex gap-3'>
      <MaskedInput
        mask='float'
        inputMode='numeric'
        value={value.time}
        label='Tempo (min)'
        placeholder='0'
        onChange={(e) =>
          setValue((state) => ({
            ...state,
            time: e,
          }))
        }
      />

      <MaskedInput
        mask='integer'
        inputMode='numeric'
        value={value.distance}
        label='Distância (m)'
        placeholder='0'
        onChange={(e) =>
          setValue((state) => ({
            ...state,
            distance: e,
          }))
        }
      />
    </div>
  )
}
